import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DexLpCollapsedWidget} from '../dex-lp-collapsed-widget';
import {DexLpCollapsedWidgetSettings} from './dex-lp-collapsed-widget-settings';

interface SettingsFormValue {
    title: string;
}

@Component({
    selector:    'dex-lp-collapsed-widget-settings',
    templateUrl: './dex-lp-collapsed-widget-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone:  false
})
export class DexLpCollapsedWidgetSettingsComponent extends WidgetImplSettingsComponentBase<DexLpCollapsedWidget> {

    @Input()
    public override widget: DexLpCollapsedWidget;

    public form: TypedForm<SettingsFormValue>;

    protected override buildForm(): void {
        const settings: DexLpCollapsedWidgetSettings = this.widget.implementationInstance.settings;

        const controls: TypedFormOwnControls<SettingsFormValue> = {
            title:   this.createTitleFormControl(settings)
        };

        this.form = new FormGroup(controls) as TypedForm<SettingsFormValue>;
    }

}
